import * as React from 'react';
import Svg, {Rect, Path} from 'react-native-svg';
import {shortcutIconColors} from 'src/components/elements/home/ShortcutButton';

const DinningShortcut = () => {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
      <Path
        d="M14.633 5.031h-1.857v1.032H11.54V5.03H9.683V4h4.95v1.031z"
        fill={shortcutIconColors().secondaryColor ?? '#58C6BB'}
      />
      <Path
        d="M12.16 7.093c5.822 0 10.603 4.325 11.123 9.847.051.55-.401.999-.954.999H1.99c-.552 0-1.004-.45-.953-1 .52-5.52 5.301-9.846 11.123-9.846z"
        fill={shortcutIconColors().primaryColor ?? '#0052BF'}
      />
      <Rect
        x={1.00098}
        y={18.9688}
        width={22.3164}
        height={1.03099}
        rx={0.515494}
        fill={shortcutIconColors().primaryColor ?? '#0052BF'}
      />
    </Svg>
  );
};
export default DinningShortcut;
